<template>
    <div class="instruction-popup-wrapper">
        <div class="mask">
            <div class="content">
                <div class="header">遊戲說明</div>
                <div class="desc">
                    <slot />
                </div>
                <round-btn
                    :background-color="buttonColor"
                    color="#ffffff"
                    font-size="1.5em"
                    align-items="center"
                    font-weight="bold"
                    justify-content="center"
                    height="70px"
                    @click="$emit('ready')"
                >
                    準備好了！
                </round-btn>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        buttonColor: String,
    },
};
</script>

<style lang="scss" scoped>
.instruction-popup-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    .mask {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #000000af;
        .content {
            position: absolute;
            padding: 30px 0;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 80%;
            max-width: 400px;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-radius: 14px;
            border: solid 2px #56a1e6;
        }
    }
    .header {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .desc {
        width: 90%;
        margin-bottom: 20px;
        font-size: 22px;
        font-weight: bold;
        strong {
            color: #ef874f;
        }
    }
}
</style>
